export const mrpVisit = (
	r: {
		firstviewdate: string | null
	} | undefined
) => {
	if (r?.firstviewdate) return { code: '1', name: '視聴済' }
	return { code: '0', name: '未視聴' }
}

export const mrpLinkFrom = (
	r: {
		linkFrom: string | null
	} | undefined
) => {
	if (!r) return undefined
	if (r.linkFrom) {
		return { code: r.linkFrom, name: r.linkFrom }
	}
	return { code: '0', name: '不明' }
}